module.exports = __webpack_public_path__ + "static/img/5diamond-tag@3x.17982bf2.png";